<template>
  <div class="tw:!last:border-b-0 tw:!last:mb-0" v-for="item, i in segments">
    <div class="tw:!flex tw:!space-x-3">
      <div class="tw:!flex tw:!flex-col tw:!py-2">
        <span class="tw:!border-2 tw:!size-3 tw:!rounded-full" />
        <span class="tw:!border-l-2 tw:!border-dotted tw:!h-full tw:!my-1 tw:!flex-1 tw:!self-center" />
        <span class="tw:!border-2 tw:!size-3 tw:!rounded-full" />
      </div>
      <div>
        <div class="tw:!font-semibold">{{ formatter.time(item.departure.time) }} - {{ item.departure.name }} ({{ item.departure.iata }})</div>
        <div class="tw:!text-sm tw:!font-normal tw:!opacity-60 tw:!py-2">Travel time: {{ (item.duration / 60) | 0 }} hr {{ item.duration % 60 }} min</div>
        <div class="tw:!font-semibold">{{ formatter.time(item.arrival.time) }} - {{ item.arrival.name }} ({{ item.arrival.iata }})</div>
      </div>
    </div>

    <div class="tw:!my-2">
      <div class="tw:!text-xs tw:!opacity-60 tw:!pl-6">
        {{ item.company.marketing.name }}
        • {{ item.equipment.name }}
        • {{ item.company.marketing.code }} {{ item.number }}
      </div>
    </div>

    <Variable v-if="segments[i + 1]" :set="segments[i + 1]!" v-slot="next">
      <div class="tw:!border-t tw:!border-dashed">
        <div v-if="item.departure.date !== next.departure.date" class="tw:!pl-6 tw:!pt-2">
          <span class="tw:!font-medium tw:!opacity-80">
            Departure • {{ dayjs(formatter.date(next.departure.date), 'DD/MM/YYYY').format('MMMM D, YYYY') }}
          </span>
        </div>
      </div>
    </Variable>
  </div>
</template>

<script lang="ts" setup>
import type { IFlight } from '~/types'
import { formatter } from '~/utils'
import Variable from './Variable.vue'
import dayjs from 'dayjs'

defineProps<{ segments: IFlight['segments'] }>()
</script>